export enum DiamondBaseColor {
  orange,
  green,
  red,
  blue,
  gray,
}

export enum DiamondBasePosition {
  up,
  middle,
  down,
}
